import BillingCmlMasterCustomerIndex from "@/components/billing_cml/customer/BillingCmlMasterCustomerIndex.vue";

let routesBillingCmlMasterCustomer= [
    {
        path: '',
        meta: {
          title: "Billing CML Master Customer",
        },
        name: "BillingCmlMasterCustomerIndex",
        component: BillingCmlMasterCustomerIndex
    },
    
]

export default routesBillingCmlMasterCustomer
  